import dynamic from "next/dynamic";

import {
  additionalInfoSchemaUk,
  addressInfoSchemaUk,
  contactInfoSchemaUk,
  passwordSchemaUk,
} from "@/validations/registration/registrationStepsUA.validation";
import { TRegistrationUkraine } from "@/types/registrationUk.types";
import { RegistrationStepUk } from "@/enums/registrationSteps.enum";

const ContactInfo = dynamic(
  () => import("@/components/auth/registration/form-components/contact-info"),
);
const Password = dynamic(
  () => import("@/components/auth/registration/form-components/password"),
);
const AddressInfoUkraine = dynamic(
  () =>
    import(
      "@/components/auth/registration/form-components/address-info-ukraine"
    ),
);
const AdditionalInfoUkraine = dynamic(
  () =>
    import(
      "@/components/auth/registration/form-components/additional-info-ukraine"
    ),
);

export const registrationStepsDataUk: TRegistrationUkraine = {
  [RegistrationStepUk.CONTACTINFO]: {
    stepName: "registration_contact_information",
    component: <ContactInfo />,
    validationSchema: contactInfoSchemaUk,
  },
  [RegistrationStepUk.PASSWORD]: {
    stepName: "password",
    component: <Password />,
    validationSchema: passwordSchemaUk,
  },
  [RegistrationStepUk.ADDITIONALINFO]: {
    stepName: "additional_information",
    component: <AdditionalInfoUkraine />,
    validationSchema: additionalInfoSchemaUk,
    needsToken: true,
  },
  [RegistrationStepUk.ADDRESSINFO]: {
    stepName: "registration_address_information",
    component: <AddressInfoUkraine />,
    validationSchema: addressInfoSchemaUk,
    needsToken: true,
  },
};
